import { clientsApiProvider, visitsApiUpsellProvider } from "../../lib/api/providers";
export const PAGE_SIZE = 20;

export const fetchVisitsOfPdc = async ({ token, pdcId }) => {
  const response = await visitsApiUpsellProvider.post(
    "/",
    {
      match: {
        pdc_id: pdcId
      },
      project: {
        startDate: 1,
        client_label: 1,
        client_id: 1
      },
      sort: { startDate: -1 },
      page: 1,
      pageSize: PAGE_SIZE
    },
    {
      headers: {
        Authorization: token
      }
    }
  );
  const _docs = response.data.docs;
  return _docs;
};

export const fetchClients = async ({ token }) => {
  const response = await clientsApiProvider.post(
    "/",
    { project: { idClient: 1, label: 1 } },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};



// WEBPACK FOOTER //
// src/pages/basepdc/api.js